import { type AmbitoDTO } from '@framework/api-client/api/inquiries/schemas/ambitoDTO.ts';
import { useMemo } from 'react';
import { getIndentScopes } from './getIndentScopes.ts';
import { normalizeScopesTreeData } from './normalizeScopesTreeData.ts';

/**
 * Hook per ottenere i dati degli ambiti in modo che siano compatibili con la TreeSelect.
 */
export function useScopesData(scopes?: AmbitoDTO[] | null) {
  const indentScopes = useMemo(() => {
    const rawScopes = scopes ?? [];
    return getIndentScopes(rawScopes);
  }, [scopes]);

  const treeDataScopes = useMemo(
    () => normalizeScopesTreeData(indentScopes),
    [indentScopes],
  );

  return treeDataScopes;
}
